import { EQuizMode } from '@constants';
import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const QuizResultsService = sdk.getService('QuizResultService');

export const useMyQuizResultsByCourse = (mode?: EQuizMode) => {
  const { data, isLoading } = useQuery({
    queryKey: ['quiz-results', 'by-course', mode],
    queryFn: () => QuizResultsService.findUserQuizStatsByCourse(mode)
  });

  return {
    quizResultsByCourse: data,
    isLoading
  };
};
